/**tab选项卡页面存储 */
import { setSessionStore, removeSessionStore } from '@/utils/storage'
import { TABS_ROUTES } from '../mutation-types'
import { remove } from 'jszip';
// 不需要出现在标签页中的路由
const whiteList = ['Redirect', 'login']
const tabsView = {
    namespaced: true,
    state: {
        tabsList: []
    },
    getters: {
        getTabs: (state) => {
            return JSON.parse(JSON.stringify(state.tabsList));
        },
    },
    mutations: {
        initTabs(state, tabsStr) {
            // 初始化标签页
            if (tabsStr) {
                state.tabsList = JSON.parse(tabsStr)
            } else {
                state.tabsList = []
            }
        },
        saveTabs(state, tabs) {
            let finalTabs = [];
            if (Array.isArray(tabs)) {
                finalTabs = JSON.parse(JSON.stringify(tabs));
            } else if (typeof tabs === 'string') {
                try {
                    const parsed = JSON.parse(tabs);
                    finalTabs = Array.isArray(parsed) ? parsed : [];
                } catch (error) {
                    console.error('标签页保存失败：JSON 解析错误', error);
                    finalTabs = [];
                }
            }
            state.tabsList = finalTabs;
            setSessionStore(TABS_ROUTES, JSON.stringify(finalTabs));
        },
        removeTabs(state) {
            state.tabsList = []
            removeSessionStore(TABS_ROUTES);
        },
        addTabs(state, route) {
            // 添加标签页
            if (whiteList.includes(route.name)) return false
            const isExists = state.tabsList.some((item) => item.name === route.name)
            if (!isExists) {
                state.tabsList.push(route)
            }
            return true
        },
        closeLeftTabs(state, route) {
            // 关闭左侧
            const index = state.tabsList.findIndex((item) => item.name === route.name)
            state.tabsList.splice(1, index - 1)
        },
        closeRightTabs(state, route) {
            // 关闭右侧
            const index = state.tabsList.findIndex((item) => item.name === route.name)
            state.tabsList.splice(index + 1)
        },
        closeOtherTabs(state, route) {
            // 关闭其他
            state.tabsList = state.tabsList.filter((item) => (item.name === route.name || item.name === 'Home'))
        },
        closeCurrentTab(state, route) {
            // 关闭当前页
            const index = state.tabsList.findIndex((item) => item.name === route.name)
            state.tabsList.splice(index, 1)
        },
        closeAllTabs(state) {
            // 关闭全部
            state.tabsList.splice(1)
            sessionStorage.removeItem(TABS_ROUTES)
        }
    }
}

export default tabsView
